import { render, staticRenderFns } from "./WebNameEdit.vue?vue&type=template&id=b920c058&scoped=true&"
import script from "./WebNameEdit.vue?vue&type=script&lang=js&"
export * from "./WebNameEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebNameEdit.vue?vue&type=style&index=0&id=b920c058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b920c058",
  null
  
)

export default component.exports